import { Provider } from "react-redux";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import store from "src/store/store";

let persistor = persistStore(store);

export interface ReduxProviderProps {
  children: React.ReactNode;
}

export const ReduxProvider = ({ children }: ReduxProviderProps) => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={undefined}>
      {children}
    </PersistGate>
  </Provider>
);
